<template>
  <div class="integral">
    <Spin v-if="isLoading" size="large" fix></Spin>
    <p class="integral-header">
      {{ $t('center.stock.name') }}：
      <span>{{ score }}</span>
      <span>
        <router-link to="/info-footer/stock">{{ $t('center.stock.statement') }}</router-link>
      </span>
    </p>
  </div>
</template>

<script>
import {
  Spin,
} from 'iview';

export default {
  name: 'center-integral',
  components: {
    Spin,
  },
  data() {
    return {
      score: 0,
      scoreInfo: {},
      isLoading: false,
    };
  },
  created() {
    this.check();
  },
  methods: {
    check() {
      // 检查登录状态
      this.isLoading = true;
      this.$service.user.isLogin()
        .then(() => this.$service.user.getUserInfo())
        .then(() => {
          // 获取用户数据
          // this.form.mobile = this.$service.user.getUser().info.phone;
          this.getScore();
        })
        .catch(() => {
          this.$router.push('/');
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    // 获取用户积分
    getScore() {
      this.scoreInfo = this.$service.user.getUser().third;
      this.score = this.$service.user.getUser().third.fdPoints;
      // return this.$service.user.score({ content: { userId: uid } })
      //   .then((res) => {
      //     this.scoreInfo = res.data;
      //     this.score = res.data.score;
      //   })
      //   .catch(() => {
      //     this.score = 0;
      //   });
    },
  },
};
</script>

<style scoped lang="sass">
  .integral
    .integral-header
      height: 58px
      line-height: 58px
      background: #ece6e6
      width: 696px
      font-size: 14px
      margin: 12px auto 0
      padding-left: 22px
      font-size: 23px
      span
        &:nth-of-type(0)
          color: #3f3d3d
        &:nth-of-type(1)
          color: #0f9675
          font-size: 26px
          margin-left: 30px
        &:nth-of-type(2)
          a
            color: #0f9675
          float: right
          font-size: 14px
          margin-right: 17px
          cursor: pointer
</style>
